import { Component, Input } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { FillSiteUserSearchViewModel, SourceSiteUserSearchViewModel } from '@services/cleanfill-api/cleanfill-api.generated';
import { StoreFillSitesService } from '@services/cleanfill-core/store-fill-sites/store-fill-sites.service';
import { StoreSourceSitesService } from '@services/cleanfill-core/store-source-sites/store-source-sites.service';
import { PortalState } from '@view-models/enums/portal-state';
import { Observable } from 'rxjs';
import { ContactInfo } from '../editable-esvr.interface';

@Component({
  selector: 'app-esvr-site-contacts',
  templateUrl: './esvr-site-contacts.component.html',
  styleUrls: ['./esvr-site-contacts.component.scss'],
})
export class EsvrSiteContactsComponent {
  PortalState = PortalState;
  sourceSiteUsers$: Observable<SourceSiteUserSearchViewModel[]>;
  fillSiteUsers$: Observable<FillSiteUserSearchViewModel[]>;
  sourceSiteRep: string;
  fillSiteRep: string;

  @Input() contactInfo: ContactInfo;
  @Input() portalState: PortalState;
  @Input() editing: boolean;
  @Input() isSourceSiteUser: boolean;
  @Input() isFillSiteUser: boolean;

  constructor(
    public formRef: ControlContainer,
    private sourceSiteStore: StoreSourceSitesService,
    private fillSiteStore: StoreFillSitesService
  ) {
    this.sourceSiteUsers$ = this.sourceSiteStore.users$;
    this.fillSiteUsers$ = this.fillSiteStore.users$;
  }

  get formGroup() {
    return this.formRef ? this.formRef.control : null;
  }
}
